import { Component, OnInit } from "@angular/core";
import { WinService } from "src/app/services/win.service";
import {
	FormGroup,
	FormBuilder,
	Validators,
	FormControl,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { ToastService } from "src/app/services/toast.service";
import { CmsService } from "src/app/services/api/cms.service";
import { Title } from "@angular/platform-browser";
import { FbpixelService } from "src/app/services/api/fbpixel.service";
import { environment as env } from "src/environments/environment";

@Component({
	selector: "app-contact",
	templateUrl: "./contact.component.html",
	styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit {
	submitted: boolean;
	private geoCoder = new google.maps.Geocoder();
	filename: any;

	constructor(
		public winService: WinService,
		private formBuilder: FormBuilder,
		private http: HttpClient,
		public cms: CmsService,
		private toast: ToastService,
		public title: Title,
		public fbpixel: FbpixelService
	) {}

	public longitude: any;
	public latitude: any;
	public zoom = 15;
	public contactForm: FormGroup;

	/**
	 * email default value
	 */
	public subject: string = "Website Inquiry: ";
	public receiver: string = env.contact.receiver;  /** "wecare@entrelabel.com"; */

	get f() {
		return this.contactForm.controls;
	}

	ngOnInit() {
		this.title.setTitle("Contact Us");
		this.contactForm = this.formBuilder.group({
			name: ["", Validators.required],
			email: [""],
			mobileno: ["", Validators.required],
			subject: ["", Validators.required],
			message: ["", Validators.required],
			attachment: [""],
			receiver: [""],
		});
		window.scrollTo(0, 0);

		this.cms.getBlockv2(5, false, true).then((f) => {
			this.getAddress(f.content.address).then((res) => {
				if (res) {
					this.longitude = res[0].geometry.location.lng();
					this.latitude = res[0].geometry.location.lat();
				}
			});
		});
	}

	sendMessage() {
		this.submitted = true;

		let subject = this.subject + " " + this.contactForm.controls.name.value;

		if (!this.contactForm.controls.email.value.length) {
			this.contactForm.controls.email.setValue("noreply@entrelabel.com");
		}

		this.contactForm.controls.subject.setValue(subject);
		this.contactForm.controls.receiver.setValue(this.receiver);

		if (this.contactForm.invalid) {
			return;
		}

		let message = this.contactForm.controls.message.value;
		message = message + "\n\n" + this.contactForm.controls.mobileno.value;
		message = this.nl2br(message, true);

		let jsonData = {
			name: this.f.name.value,
			receiver: this.f.receiver.value,
			email: this.f.email.value,
			subject: this.f.subject.value,
			attachment: this.f.attachment.value,
			message: message,
			from: 'entrelabel',
		};

		/* continue */
		// let fb_api_url = "https://us-central1-toda-app-d630e.cloudfunctions.net/sendMailOverHTTPv2";
		let fb_api_url = 'https://mailer.entrelabel.com';

		this.cms.setLoader(true);

		this.http.post(fb_api_url, jsonData).subscribe((res) => {
			let result: any = res;
			if (result.status == 200) {
				this.toast.add("You successfully sent a message to Entrelabel.", "success");
				this.fbpixel.fbq('track', 'Contact', {});
			} else {
				this.toast.add("Please try again.", "danger");
			}
			this.submitted = false;
			this.emptyField();
			this.cms.setLoader(false);
		});
	}
	nl2br(str, is_xhtml) {
		if (typeof str === "undefined" || str === null) {
			return "";
		}
		var breakTag =
		is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";
		return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1" + breakTag + "$2");
	}

	emptyField() {
		this.f.name.setValue("");
		this.f.email.setValue("");
		this.f.subject.setValue("");
		this.f.attachment.setValue("");
		this.f.message.setValue("");
		this.f.mobileno.setValue("");
	}

	setAttachment($file) {
		this.filename = $file.target.files[0].name;
		this.getBase64($file.target.files[0]).then((res) => {
		this.f.attachment.setValue(res);
		});
	}

	getBase64(file) {
		return new Promise((resolve) => {
			var reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = function () {
				resolve(reader.result);
			};
			reader.onerror = function (error) {
			};
		});
	}

	public getAddress(query: string): any {
		return new Promise((resolve, reject) => {
			this.geoCoder.geocode({ address: query }, (result) => {
				if (result.length > 0) {
					if (result.length > 0) {
						resolve(result);
					} else {
						reject({ message: "no results found" });
					}
				} else {
					reject({ message: "no results found" });
				}
			});
		});
	}

	isNumberKey(evt: any) {
		let charCode = evt.which ? evt.which : evt.keyCode;
		if (
			charCode == 9 ||
			charCode == 8 ||
			/* charCode == 110 || 
			charCode == 190 ||  */
			(charCode >= 96 && charCode <= 105) ||
			(charCode >= 48 && charCode <= 57) ||
			(charCode >= 37 && charCode <= 40)
		) {
			return true;
		} else {
			return false;
		}
	}
}
